import React from 'react'
import ReactDOM from 'react-dom/client'
import { QueryClientProvider } from '@tanstack/react-query'
import App from './App'
import './index.css'


import { AuthProvider } from '@/contexts/AuthContext'
import { StoreProvider } from '@/contexts/StoreContext'
import { SettingsProvider } from '@/contexts/SettingsContext'
import { WorkspaceProvider } from '@/contexts/WorkspaceContext'
import { queryClient } from '@/lib/query-client'
import { trpc, trpcClient } from '@/lib/trpc'

ReactDOM.createRoot(document.getElementById('root')!).render(
  <React.StrictMode>
    <trpc.Provider client={trpcClient} queryClient={queryClient}>
      <QueryClientProvider client={queryClient}>
        <AuthProvider>
          <WorkspaceProvider>
            <StoreProvider>
              <SettingsProvider>
                <App />
              </SettingsProvider>
            </StoreProvider>
          </WorkspaceProvider>
        </AuthProvider>
      </QueryClientProvider>
    </trpc.Provider>
  </React.StrictMode>,
)
